<script lang="ts" setup>
withDefaults(defineProps<{ icon: string; text: string; disabled?: boolean }>(), {
  disabled: false
});
</script>

<template>
  <a-button :disabled="disabled" type="text" size="small" class="!flex flex-center !px-0 !rounded-md hover:!text-inherit"><img class="w-4 mr-1" :src="icon" alt="" />{{ text }}</a-button>
</template>
<style scoped>
:disabled {
  @apply !text-colorTextQuaternary opacity-70
}
:disabled img {
  @apply !opacity-50
}
</style>

